import { createFileRoute } from '@tanstack/react-router';
import { BrandingAssetEditorPage } from '@/pages/member-portal/branding/BrandingAssetEditorPage';

// Branding asset editor. `$id` is either an asset id (edit) or the literal `new`.
function MemberPortalBrandingAssetEditorRoute() {
	return <BrandingAssetEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/branding/$id')({
	component: MemberPortalBrandingAssetEditorRoute,
});
